import {
    LOAD_MENUS_SUCCESS, RESET_MENUS, REORDER_MENUS_SUCCESS
} from '../../../actions/types';

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
    switch(action.type) {
        case LOAD_MENUS_SUCCESS:
            return action.payload;
        case REORDER_MENUS_SUCCESS:
            return action.payload;
        case RESET_MENUS:
            return INITIAL_STATE;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/restaurants/posmenu/MenusReducer.js